<div class="content">
    <section>
        <h2>AKTIVITÄTEN</h2>
        <p>In unserem Turnverein gibt es immer viel zu tun und zu entdecken. Wir bieten eine breite Palette an Aktivitäten für Menschen jeden Alters und jeder Fitnessstufe. Aber nicht nur sportliche Betätigung steht bei uns im Vordergrund, sondern auch der Spaß und das Miteinander. Schau doch einfach mal vorbei und lerne uns kennen!</p>
        <app-activity-builder [activities]="activities"></app-activity-builder>
    </section>
</div>